import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import Blogimg1 from "../../assets/images/blogZHimg1.webp";
import Blogimg2 from "../../assets/images/blogZHimg2.webp";
import Blogimg3 from "../../assets/images/blogZHimg3.webp";

export const BlogZeroHero = ({ counter }) => {
  return (
    <div className="blog-bg1 py-5">
      <Container style={{ overflow: "hidden" }}>
        <div className="row">
          <div className="d-flex flex-column flex-lg-row p-lg-3 mt-3">
            <div
              className="col-12 col-md-12 col-lg-6 pb-4"
              data-aos="fade-right"
            >
              <div className="px-lg-3">
                <h5 className="text-start">"Transforming Lives with the Clothing Business"</h5>
              </div>
              <div className="d-flex flex-column flex-md-row justify-content-start align-items-center gap-2 px-lg-3">
                <div className="d-flex flex-column gap-2">

                  <p className="mb-0 fs-20 fs-sm-14">
                    In today’s world, success is not just about finding the right opportunity it’s about taking action at the right time. At Kesaria Textile Company, we have been empowering individuals, startups, and entrepreneurs since 1977, turning their dreams into reality through the power of the clothing business.
                  </p>
                  <p className="mb-0 fw-bold fs-20 fs-sm-14">
                    From a Small Step to a Giant Leap
                  </p>
                  <p className="mb-0 fs-20 fs-sm-14">
                    The textile industry has always been a goldmine for those who dare to dream big. Whether you are a small retailer, a first-time entrepreneur, or someone looking for financial independence, the clothing business offers limitless opportunities. Our journey from Surat to exporting in 80+ countries is a testament to the fact that passion, quality products, and the right support system can take you from zero to hero.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-12 col-lg-6 mt-3 mt-md-0  mb-5 mb-md-0 animationmove d-flex justify-content-end">
              <div style={{ position: "relative" }}>
                <img
                  src={Blogimg1}
                  alt="blog-main-image"
                  className="blog-main-image them-borderradius"
                  loading="lazy"
                />
                <div className="blog-redimage"></div>
                <div className="bg-danger d-flex flex-column justify-content-center align-items-center blog-secon-div animationmove">
                  <img alt="blog image" className="img-fluid py-1" src={Blogimg2} loading="lazy" />
                  <div className="blog-zh-p1 py-1">{counter}+</div>
                  <p className="blog-zh-p2">Started With Kesaria</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};
